export function useContains(var_type) {
	return ['6', '13', '14', '35', '36', '37'].indexOf(String(var_type)) > -1;
}

export function sortPropsByValue(obj) {
	return Object.keys(obj).sort((a, b) => obj[b] - obj[a]);
}
